import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from 'material-ui/Table';

import {
  constructionToStr,
  resinContentToPercent,
  thickness2inch
} from '../../../lib/material';
import { DK_DECIMALS, DF_DECIMALS } from '../../../constants/globals';
import { acceptedColumns, showColumnFactory } from './columns';
import { materialPropType, unitShape } from '../../../lib/shapes';
import { inchToString } from '../../../lib/unitConversions';

const extranctMhzValues = (material, key) => (
  material[key].reduce((acc, cur) => {
    acc[cur.mhz] = cur.value;
    return acc;
  }, {})
);

export const MaterialRow = (props) => {
  const { columns, material, mhzs, selectRender, handleClick, lengthUnit } = props;
  const showColumn = showColumnFactory(columns);
  const id = material.id.toString();
  const product = material.product;
  const construction = constructionToStr(material)
  const resinContent = resinContentToPercent(material.resinContent);
  const thickness_in = thickness2inch(material.thickness)
  const onClick = () => handleClick && handleClick(id);
  const dks = extranctMhzValues(material, 'dk');
  const dfs = extranctMhzValues(material, 'df');

  return (
    <TableRow hover key={id} value={id} onClick={onClick}>
      {selectRender && selectRender(material)}
      {showColumn('product', (
        <TableCell component="th" scope="row">
          {product}
        </TableCell>
      ))}
      {showColumn('construction', (
        <TableCell component="th" scope="row">
          {construction}
        </TableCell>
      ))}
      {showColumn('resinContent', (
        <TableCell component="th" scope="row" numeric>
          {resinContent ? resinContent.toFixed(1) : 'N/A'}
        </TableCell>
      ))}
      {showColumn('thickness', (
        <TableCell component="th" scope="row" numeric>
          {inchToString(thickness_in, lengthUnit.name, false)}
        </TableCell>
      ))}
      {showColumn('dkdf', mhzs.map((mhz) => (
        <TableCell key={mhz} numeric>
          {dks[mhz] && dfs[mhz] ? [
            <div key="dk">{dks[mhz].toFixed(DK_DECIMALS)}</div>,
            <div key="df">{dfs[mhz].toFixed(DF_DECIMALS)}</div>
          ] : (
            <div>N/A</div>
          )}
        </TableCell>
      )))}
    </TableRow>
  );
}

MaterialRow.propTypes = {
  material: PropTypes.shape(materialPropType).isRequired,
  columns: PropTypes.arrayOf(PropTypes.oneOf(acceptedColumns)),
  mhzs: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectRender: PropTypes.func,
  handleClick: PropTypes.func,
  lengthUnit: PropTypes.shape(unitShape).isRequired,
}

MaterialRow.defaultProps = {
  selectRender: undefined,
  columns: undefined,
  handleClick: undefined,
}

export default  MaterialRow;


// WEBPACK FOOTER //
// ./src/components/common/MaterialsTable/MaterialRow.js